import { createReducer, updateDeepState } from '../handlers'
import types from './types'

const initialState = {
  faqConsoleAssistant: {
    isActive: false
  },
  faqConsole: {
    isActive: false
  },
  faqGenerative: {
    isActive: false
  },
  crmMarketing: {
    isActive: false
  },
  metricsBasic: {
    isActive: false
  },
  smartChat: {
    isActive: false
  },
  sentimentAnalysis: {
    isActive: false
  },
  pluginEcommerce: {
    isActive: false
  },
  smartChatEcommerce: {
    isActive: false
  },
  topic: {
    isActive: false
  },
  inchat: {
    isActive: false
  },
  automaticAssignment: {
    isActive: false
  },
  slackAPI: {
    isActive: false
  },
  crms: {
    isActive: false
  },
  publicAPI: {
    isActive: false
  },
  externalIdentification: {
    isActive: false
  }
}

/**
 * Upsert modules
 * @param {Object} action
 * @param {Object<initialState>} action.modules
 */
const upsert = (state, action) => {
  const { modules } = action

  return updateDeepState(state, modules)
}

export default createReducer(initialState, {
  [types.upsert]: upsert,
})
